module.exports = __webpack_public_path__ + "img/mainEventEnd_logo_20250604.1e86d8d7.png";